//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "TopEntityComponentSeason",
  components: {
    Icon24FillSeasons: () => import('@/assets/icons/Icon24FillSeasons.svg?inline')
  },
  props: {
    season: {
      type: String,
      default: () => ''
    }
  }
}
